import React, { Component } from 'react'

class Shell extends Component {
  render () {
    const {children} = this.props
    const styles = {
      margin: '2em auto',
      width: '400px'
    }

    return (
      <div className='shell' style={styles}>
        {children}
      </div>
    )
  }
}

export default Shell



// WEBPACK FOOTER //
// ./src/containers/shell/index.js